// import * as firebase from 'firebase';
import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/database';
import { getRequiredEnv } from '../../utils/helpers';
import { firebaseConfig } from './config';

export type AuthCredential = {
  providerId: string;
  signInMethod: string;
  toJSON(): Object;
};
export interface ApplicationVerifier {
  type: string;
  verify(): Promise<string>;
  clear(): void;
  render(): Promise<number>;
}
export type ConfirmationResult = {
  confirm(verificationCode: string): Promise<firebase.auth.UserCredential>;
  verificationId: string;
};

export type UserCredential = {
  additionalUserInfo?: firebase.auth.AdditionalUserInfo | null;
  credential: firebase.auth.AuthCredential | null;
  operationType?: string | null;
  user: firebase.User | null;
};

class Firebase {
  private auth: firebase.auth.Auth;
  // private googleProvider: firebase.auth.AuthProvider;
  // private facebookProvider: firebase.auth.AuthProvider;
  // private twitterProvider: firebase.auth.AuthProvider;
  private db: firebase.database.Database;

  constructor() {
    firebaseConfig.appId = getRequiredEnv('NX_FIREBASE_APP_ID');
    firebaseConfig.measurementId = getRequiredEnv('NX_FIREBASE_MEASUREMENT_ID');
    firebase.initializeApp(firebaseConfig);

    /* Helper */
    //serverValue = firebase.database.ServerValue;
    //emailAuthProvider = firebase.auth.EmailAuthProvider;

    /* Firebase APIs */
    this.auth = firebase.auth();
    this.db = firebase.database();

    /* Social Sign In Method Provider */
    // this.googleProvider = new firebase.auth.GoogleAuthProvider();
    // this.facebookProvider = new firebase.auth.FacebookAuthProvider();
    // this.twitterProvider = new firebase.auth.TwitterAuthProvider();
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email: string, password: string) =>
    this.auth.createUserWithEmailAndPassword(email, password);
  //firebase.auth().signInWithEmailAndPassword(email, password)
  //   .then((user) => {
  //     // Signed in
  //     // ...
  //   })
  //   .catch((error) => {
  //     var errorCode = error.code;
  //     var errorMessage = error.message;
  //   });

  doSignInWithEmailAndPassword = (email: string, password: string) =>
    this.auth.signInWithEmailAndPassword(email, password);

  // doSignInWithGoogle = () => this.auth.signInWithPopup(this.googleProvider);
  //
  // doSignInWithFacebook = () => this.auth.signInWithPopup(this.facebookProvider);
  //
  // doSignInWithTwitter = () => this.auth.signInWithPopup(this.twitterProvider);

  //Анонимный вход нового пользователя
  doSignInAnonymously = async () => {
    try {
      return await this.auth.signInAnonymously();
    } catch (error) {
      throw new Error(error);
    }
    // this.auth
    //   .signInAnonymously()
    //   .then(() => {
    //     // Signed in..
    //   })
    //   .catch((error) => {
    //     const errorCode = error.code;
    //     const errorMessage = error.message;
    //     // ...коды для обработки ошибок (вынести потом их:
    //     if (errorCode === 'auth/operation-not-allowed') {
    //       alert('You must enable Anonymous auth in the Firebase Console.');
    //     } else {
    //       console.error(error);
    //     }
    //   });
  };

  doSignInWithPhoneNumber = (
    phoneNumber: string,
    recaptchaVerifier: ApplicationVerifier
  ) => {
    return this.auth.signInWithPhoneNumber(phoneNumber, recaptchaVerifier);
  };

  doSignOut = () => this.auth.signOut();
  //.then( () => {
  //   // Sign-out successful.
  // }).catch( (error) => {
  //   // An error happened.
  // });

  doPasswordReset = (email: string) => this.auth.sendPasswordResetEmail(email);

  doSendEmailVerification = () =>
    this.auth.currentUser &&
    this.auth.currentUser.sendEmailVerification({
      // url: process.env.NX_CONFIRMATION_EMAIL_REDIRECT,
      url: getRequiredEnv('NX_API_ENDPOINT'),
    });

  doPasswordUpdate = (password: string) =>
    this.auth.currentUser && this.auth.currentUser.updatePassword(password);

  // *** Merge Auth and DB User API *** //
  onAuthUserListener = (
    next: (arg0: firebase.User | null) => void,
    fallback: () => void
  ) =>
    //Наблюдатель за входом пользователей
    this.auth.onAuthStateChanged((authUser: firebase.User | null) => {
      if (authUser) {
        this.user(authUser.uid)
          .once('value')
          .then((snapshot) => {
            const dbUser = snapshot.val();

            // default empty roles
            if (!dbUser.roles) {
              dbUser.roles = {};
            }

            // merge auth and db user
            authUser = {
              uid: authUser && authUser.uid,
              email: authUser && authUser.email,
              emailVerified: authUser && authUser.emailVerified,
              providerData: authUser && authUser.providerData,
              ...dbUser,
            };
            //console.info('onAuthUserListener', authUser);
            next(authUser);
          });
      } else {
        fallback();
      }
    });

  // *** User API ***

  user = (uid: string) => this.db.ref(`users/${uid}`);

  users = () => this.db.ref('users');

  getUser(uid: string) {
    return this.user(uid);
  }

  doSignInWithCredential = (
    verificationId: string,
    code: string
  ): Promise<UserCredential> => {
    const credential = firebase.auth.PhoneAuthProvider.credential(
      verificationId,
      code
    );
    return this.auth.signInWithCredential(credential);
  };

  // *** Message API ***

  // message = (uid: string) => this.db.ref(`messages/${uid}`);
  //
  // messages = () => this.db.ref('messages');
}

export default Firebase;
